// @flow

export default class Url {
  static dateUrlRegExp = /^((?:19|20)(?:[0-9]){2}-(?:0[1-9]|1[0-2])-(?:0[1-9]|[1,2][0-9]|3[0,1]))$/;

  static getDatesFilter() {
    const splittedUrl = window.location.href.split('/');
    const fromDate = splittedUrl[splittedUrl.length - 3];
    const toDate = splittedUrl[splittedUrl.length - 2];

    if (!(Url.dateUrlRegExp.test(fromDate) && Url.dateUrlRegExp.test(toDate))) return {};

    return { fromDate, toDate };
  }

  static getFromDateFilter() {
    return Url.getDatesFilter().fromDate;
  }
}
